module.exports = __webpack_public_path__ + "static/media/microType.ee2bedf5.svg";